export const hasResolutionMismatch = (graphic: Graphic, canvas: Canvas): boolean => {
  if (!graphic.config.resolution || !canvas.width || !canvas.height) return false;
  return !(
    graphic.config.resolution.width === canvas.width &&
    graphic.config.resolution.height === canvas.height
  );
};
